/**
 * @generated SignedSource<<7c15e3ca3b91650bbecb3c74f0cbd948>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "TokenResponse",
    "kind": "LinkedField",
    "name": "refresh",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tokenType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessToken",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refreshToken",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createRelayEnvironmentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createRelayEnvironmentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "82f655944c436a3b4158a7589a297559",
    "id": null,
    "metadata": {},
    "name": "createRelayEnvironmentMutation",
    "operationKind": "mutation",
    "text": "mutation createRelayEnvironmentMutation(\n  $request: RefreshRequestInput\n) {\n  refresh(request: $request) {\n    tokenType\n    accessToken\n    refreshToken\n  }\n}\n"
  }
};
})();

node.hash = "37a69eaa227a9cfcc16f9c2fa334a084";

module.exports = node;
